<template>
	<v-card>
		<v-card-title>编辑订单信息</v-card-title>
		<v-card-text>
			<div class="d-flex flex-row align-center">
				<date-picker
					v-model="form.date"
					label="选择订单日期，不可修改"
					:xxdisabled="form.id ? true : false"
				></date-picker>
			</div>
			<v-chip color="warning" v-if="form.totalqty && form.totalamt">
				合计{{ form.totalqty }} 克 - {{ form.totalamt }}元
			</v-chip>
			<div class="d-flex flex-column align-center">
				<div class="d-flex flex-row align-center justify-start w-100">
					<template v-if="selectedBean">
						<div v-if="selectedBean" class="ml-2">
							{{ selectedBean.name }}({{ selectedBean.code }} -
							<v-chip color="warning">库存：{{ selectedBean.roastedstock }} 克</v-chip>
							)
						</div>
					</template>
					<bean-selector @selected="onBeanSelected" :show-selected="false"></bean-selector>
				</div>
				<!-- <template v-if="selectableBatches && selectableBatches.length > 0">
					<v-select
						v-model="selectedBatchId"
						:items="selectableBatches"
						:item-title="(item) => `${item.date} ${item.bean_type} ${item.type} - ${item.currentqty}g`"
						item-value="id"
						label="选择批次"
					></v-select>
				</template> -->
				<div v-if="selectedBean" class="d-flex flex-row justify-start align-center w-100">
					<bean-batch-selector @selected="onBatchSelected" :bean-id="selectedBean.id" bean-type="roasted">
						<template v-if="selectedBatch">{{ selectedBatch.date }} {{ selectedBatch.bean_type }}</template>
						<template v-else>选择批次</template>
					</bean-batch-selector>
					<v-text-field
						v-model.number="selectedBatchQty"
						id="beanTemp"
						variant="outlined"
						style="max-width: 10rem; width: 10rem"
					></v-text-field>
					克/
					<template v-if="selectedBatch">{{ selectedBatch.currentqty }} 克</template>
					<v-btn
						color="primary"
						@click="addItem"
						v-if="selectedBatch && selectedBatch.id && selectedBatchQty > 0"
					>
						添加
					</v-btn>
				</div>
			</div>
			<v-textarea
				rows="1"
				variant="outlined"
				v-model="form.memo"
				:error-messages="errors.memo"
				label="备注"
			></v-textarea>
			<v-table v-if="form.items && form.items.length > 0" density="compact">
				<thead>
					<tr>
						<th class="text-left">名称</th>
						<th class="text-left">价格</th>
						<th class="text-left">数量</th>
						<th class="text-left">小计</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, i) in form.items" :key="i">
						<td>{{ item.bean_name }}({{ item.bean_id }})</td>
						<td>{{ item.price }}</td>
						<td>{{ item.qty }} 克</td>
						<td>{{ item.amt }}元</td>
						<td>
							<v-btn @click="form.items.splice(i, 1)" text color="error"><v-icon>$delete</v-icon></v-btn>
						</td>
					</tr>
				</tbody>
			</v-table>
			<slot name="actions" :object="form"></slot>
		</v-card-text>
	</v-card>
</template>

<script>
import BeanBatchSelector from '../bean/BatchSelector.vue'
import BeanSelector from '../bean/Selector.vue'
import DatePicker from '../common/DatePicker.vue'
import ShopAccountSelector from '../shop/AccountSelector.vue'
import { clone, cloneDeep } from 'lodash-es'

export default {
	name: 'OrderForm',
	components: {
		BeanSelector,
		BeanBatchSelector,
		ShopAccountSelector,
		DatePicker
	},
	props: {
		value: { type: Object, default: () => ({}) },
		errors: { type: Object, default: () => ({}) }
	},
	data() {
		return {
			form: this.value ? clone(this.value) : {}, // 初始化为 value 的值
			selectedBean: null,
			selectedBeanQty: 0,
			selectedUser: null,
			selectedAccount: null,
			selectableBatches: [],
			selectedBatch: null,
			selectedBatchQty: null
		}
	},
	computed: {},
	watch: {
		value: {
			//当发生外部变化时
			handler(val) {
				if (val) {
					this.form = clone(val)
					this.calcTotal()
				}
			},
			deep: true
		}
	},
	methods: {
		onBatchSelected(batchids, batches) {
			console.log('onBatchSelected', batchids, batches)
			this.selectedBatch = batches[0]
		},
		onBeanSelected(beanids, beans) {
			this.selectedBean = beans[0]

			//如果有之前的batch选择，则清空重选
			if (this.selectedBatch) {
				this.selectedBatch = null
			}
		},
		loadAccount(id) {
			this.$api.shop.getAccountById(id, (r) => {
				if (r && r.length > 0) {
					this.selectedAccount = r
				} else {
					this.selectedAccount = null
				}
			})
		},
		onAccountSelected(ids, accounts) {
			this.selectedAccount = accounts[0]
			this.form.shopaccount_id = ids[0]
		},
		calcTotal() {
			if (!this.form.items || this.form.items.length === 0) {
				this.form.totalamt = 0
				this.form.totalqty = 0
				return
			}
			this.form.totalamt = this.form.items.reduce((acc, cur) => acc + cur.amt, 0)
			this.form.totalqty = this.form.items.reduce((acc, cur) => acc + cur.qty, 0)
			//FIXME 注意： 1分钱问题：当值为0.075时 tofix会编程0.07的那是后端计算后存储的是四舍五入的0.08
			this.form.totalamt = parseFloat(parseFloat(this.form.totalamt).toFixed(2))
			this.form.totalqty = parseInt(this.form.totalqty)
			console.log('aaa', this.form)
		},
		addItem() {
			if (!this.form.items) this.form.items = []
			let ex = this.form.items.find((e) => e.beanbatch_id == this.selectedBatch.id)
			if (ex) {
				ex.qty += parseInt(this.selectedBatchQty)
				ex.amt = ex.qty * ex.price
			} else {
				let price = this.calcPricePerGram(this.selectedBean, this.selectedUser)
				let amt = parseInt(this.selectedBatchQty) * price
				this.form.items.push({
					bean_id: this.selectedBean.id,
					bean_name: this.selectedBean.name,
					beanbatch_id: this.selectedBatch.id,
					qty: parseInt(this.selectedBatchQty),
					price: parseFloat(price),
					amt
				})
			}
			this.calcTotal()
			this.selectedBatchQty = null
			this.selectedBatch = null
			this.$emit('update:value', this.form)
		},
		calcPricePerGram(bean, user) {
			return bean.cprice / 1000 //LATER 现在只是返回零售价
		}
	}
}
</script>
